import { render, staticRenderFns } from "./ColorfulOptions.vue?vue&type=template&id=5c6fe5ba&scoped=true&"
import script from "./ColorfulOptions.vue?vue&type=script&lang=js&"
export * from "./ColorfulOptions.vue?vue&type=script&lang=js&"
import style0 from "./ColorfulOptions.vue?vue&type=style&index=0&id=5c6fe5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6fe5ba",
  null
  
)

export default component.exports